import React, { useEffect, useState } from "react";
import BreadCrumbs from "./BreadCrumbs";
import Link from "next/link";
import Loader from "./Loader";
import Footer from "./Footer";
import RewardsFAQ from "./RewardsFAQ";
import currency from "currency.js";
import RewardsHistory from "./RewardsHistory";
import { useAuth } from "../services/hooks/useAuth";
import { useGlobal } from "../services/hooks/useGlobal";
import { useLoyaltyInfo } from "../services/hooks/useLoyaltyInfo";

export default React.memo(function Rewards() {
  const [totalReferrals, setTotalReferrals] = useState(0);
  const { user } = useAuth(true);
  const { fetchLoyaltyInfo, loyaltyInfo } = useLoyaltyInfo();
  const { loyaltyPointsDollarEquivalent } = useGlobal();

  useEffect(() => {
    if (user) {
      fetchLoyaltyInfo(user.loyaltyId);
    }
  }, [user]);

  useEffect(() => {
    if (loyaltyInfo) {
      setTotalReferrals(loyaltyInfo.referred.length);
    }
  }, [loyaltyInfo]);

  if (!user) {
    return <Loader absoluteCenter />;
  }

  return (
    <>
      <BreadCrumbs
        links={[
          {
            url: "/",
            name: "Home",
          },
          {
            url: "/rewards",
            name: "Rewards",
          },
        ]}
      />

      <section>
        <div className="container">
          <div className="row">
            <div className="col-12 text-center mt-8 mb-12">
              <h3>Chic Beauty Box Loyalty Program</h3>
              <h1>First things first - Everyone gets rewarded!</h1>
            </div>
            <div className="col-12 text-center">
              <p className="h6">Hi {user?.firstName}, here are your stats:</p>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-6">
              <div className="card mb-3 text-center">
                <div className="card-header">Rewards</div>
                <div className="card-body text-dark">
                  <h5 className="card-title">Total Points</h5>
                  <p className="card-text font-size-h1">{user.loyaltyPoints}</p>
                  <p>
                    That's{" "}
                    <strong>
                      {currency(
                        user.loyaltyPoints * loyaltyPointsDollarEquivalent
                      ).format()}
                    </strong>{" "}
                    to spend in the shop
                  </p>
                  <Link href="/stores/add-ons">
                    <a className="text-dark">
                      Start shopping
                      <i className="fe fe-chevron-right"></i>
                    </a>
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6">
              <div className="card mb-3 text-center">
                <div className="card-header">Referrals</div>
                <div className="card-body text-dark">
                  <h5 className="card-title">Total Referrals</h5>
                  <p className="card-text font-size-h1">{totalReferrals}</p>
                  <Link href="/refer">
                    <a className="text-dark">
                      Refer a friend to earn rewards
                      <i className="fe fe-chevron-right"></i>
                    </a>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <RewardsHistory loyaltyInfo={loyaltyInfo} />

      <section className="mb-10">
        <div className="container">
          <h4 className="text-center">
            Your Chic Beauty Box Loyalty Program Benefits
          </h4>
          <p className="text-center">
            Chic Beauty Box makes it super easy to get rewarded for your
            loyalty. Each time you spend on our website, you automatically earn
            Loyalty Points. This also applies to your first purchase. Your Chic
            Points can be redeemed in the shop for full-size products.
          </p>
        </div>
      </section>
      <section className="mb-10">
        <div className="container">
          <h4 className="text-center">
            Here are some of the ways to earn points:
          </h4>
          <ul className="list-group list-group-flush text-center w-md-50 horizontal-center">
            <li className="list-group-item">
              <strong>1</strong> point for every dollar you spend in the shop
            </li>
            <li className="list-group-item">
              <strong>10</strong> points when you leave a product review
            </li>
            <li className="list-group-item">
              <strong>100</strong> points when you refer a friend
            </li>
          </ul>
          <p className="text-center">
            <strong>What your Loyalty Points are worth:</strong> Points can be
            redeemed as a payment toward any full-size product in the Shop.
          </p>
          <h1 className="text-center">10 points = $1</h1>
          <h6 className="text-center">
            <Link href="/refer">
              <a>Refer a friend</a>
            </Link>{" "}
            to start earning.
          </h6>
        </div>
      </section>

      <RewardsFAQ />
      <Footer />
    </>
  );
});
